import React from "react";
import { useHistory } from "react-router-dom";

import * as S from "./styles";
import { IProps } from "./types";
import { Container, Row, Col } from "react-bootstrap";
import { getPrice, getPriceWithFraction, processVariant } from "@utils";
import styled from "styled-components";
import { MgsLogoIcon } from "@components/ProductPage/ProductDetailSummary";
import MgsIcon from "/src/images/icons/mgs-logo.png";

const VariantSpan = styled.span`
  display: block;
  white-space: pre;
  font-size: 0.7rem;
`;

const OrderItems: React.FC<IProps> = ({ subs }: IProps) => {
  const history = useHistory();

  return (
    <S.Wrapper>
      <S.OrderItemsCard>
        <S.OrderItemsCardHeader>
          <S.OrderItemsCardHeaderTitle>
            Item(s) In Order
          </S.OrderItemsCardHeaderTitle>
        </S.OrderItemsCardHeader>
        {subs.map((sub, i) => {
          var codCharge = '';
          if ((sub?.codAmount?.amount ?? 0) != 0) {
            codCharge = '(COD Charge : ' + getPriceWithFraction(
              sub?.codAmount?.amount ?? 0, true, false) + ')';
          }
          return (
            <S.OrderItemsCardBody key={i}>
              <S.OrderItemsSellerName>{`${sub.seller.name} ${codCharge}`}</S.OrderItemsSellerName>
              <Container style={{ padding: "0" }}>
                {sub.lines.map((line, j) => {
                  const variant = line?.variant;
                  const {
                    variantImageUrl,
                    variantImageAlt,
                    attributeImageUrl,
                    attributeImageAlt,
                    showVariants,
                    variantName,
                    productBrand,
                    productName,
                  } = processVariant(variant, line?.productName);
                  return (
                    <Row
                      key={j}
                      style={{ marginTop: "1rem", marginBottom: "1rem" }}
                    >
                      <Col>
                        <S.OrderItemsProduct canceled={line.isCanceled.toString()} onClick={() => history.push(variant?.product?.urlForGraphql)} >
                          <Col xs={3}>
                            <img
                              src={variantImageUrl}
                              alt={variantImageAlt}
                              style={{ width: "100%" }}
                            />
                          </Col>
                          <Col xs={9}>
                            <S.OrderItemsBrandName>
                              {productBrand}
                            </S.OrderItemsBrandName>
                            <S.OrderItemsProductName>
                              {productName}
                            </S.OrderItemsProductName>
                            {showVariants && (
                              <VariantSpan>
                                <img
                                  src={attributeImageUrl}
                                  alt={attributeImageAlt}
                                  width={12}
                                />
                                {` ${variantName}`}
                              </VariantSpan>
                            )}
                            <S.OrderItemsQuantity>
                              Qty: {line?.quantity}
                            </S.OrderItemsQuantity>
                            {
                              variant.product.productType.isMgs && (
                                <div>
                                  <MgsLogoIcon
                                    src={MgsIcon} />
                                </div>
                              )
                            }
                            {
                              line.isCanceled ?
                                <S.OrderItemsPriceStrike>
                                  {getPrice(line?.unitPrice?.gross?.amount, true)}
                                </S.OrderItemsPriceStrike>
                                :
                                <S.OrderItemsPrice>
                                  {getPrice(line?.unitPrice?.gross?.amount, true)}
                                </S.OrderItemsPrice>
                            }
                          </Col>
                        </S.OrderItemsProduct>
                      </Col>
                    </Row>
                  );
                })}
              </Container>
            </S.OrderItemsCardBody>
          );
        })}
      </S.OrderItemsCard>
    </S.Wrapper>
  );
};

export { OrderItems };
